import React from "react";
import { connect } from "react-redux";
import { updateShippingMethod } from "MODULES/companies/actions";
import { form, Form as AppForm } from "MODULES/shared/components/Forms";
import { ShippingMethod } from "MODULES/shared/components/Forms/FormSections";
import validate from "../validate";

export function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <ShippingMethod />
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(
  state => ({
    resourceID: state.companyDetail.getIn(["company", "id"])
  }),
  dispatch => ({
    onSubmit: data => dispatch(updateShippingMethod(data))
  })
)(
  form({
    form: "editShippingMethod",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/ShippingMethods/Edit/Form.jsx